import React, { Component } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import PropTypes from "prop-types";

class SalesAnalytics extends Component {
  constructor(props) {
    super(props)

    this.state = {
      series: this.props.lab,
      options: {
        maintainAspectRatio: false,
        labels: ["Verified Labs", "Unverified Labs"],
        colors: ["#556ee6", "#f46a6a"],
        legend: { show: !1 },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
            },
          },
        },
      },
    }
  }
  render() {
    const { lab} = this.props;
    return (
      <React.Fragment>
        <Col xl="4">
          <Card>
            <CardBody>
              <h4 className="card-title mb-4">Lab Analytics</h4>

              <div>
                <div id="donut-chart" className="apex-charts">
                  <ReactApexChart
                    options={this.state.options}
                    series={this.props.lab}
                    type="donut"
                    height={262}
                  />
                </div>
              </div>

              <div className="text-center text-muted">
                <Row>
                  <Col xs="4">
                    <div className="mt-4">
                      <p className="mb-2 text-truncate">
                        <i className="mdi mdi-circle text-primary me-1"/>
                        verified
                      </p>
                      <h5>Total: {this.props.lab[0]}</h5>
                    </div>
                  </Col>
                  <Col xs="4">

                  </Col>
                  <Col xs="4">
                    <div className="mt-4">
                      <p className="mb-2 text-truncate">
                        <i className="mdi mdi-circle text-danger me-1"/>
                        unverified
                      </p>
                      <h5>Total: {this.props.lab[1]}</h5>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}
SalesAnalytics.propTypes = {
  lab: PropTypes.array,
  title:PropTypes.any,
  title1:PropTypes.any,
  title2:PropTypes.any,
  // onGetReviews: PropTypes.func,
};


export default SalesAnalytics
